import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App.jsx";

window.addEventListener('keydown', (e) => {
    document.querySelectorAll('.program-list__select-wrapper').forEach((el) => {
        el.classList.add('using-keyboard');
    });
});

window.addEventListener('mousedown', () => {
    document.querySelectorAll('.program-list__select-wrapper').forEach((el) => {
        el.classList.remove('using-keyboard');
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const el = document.getElementById("react-root");
    if (el) {
        const root = ReactDOM.createRoot(el);
        let properties = document.querySelector('[data-properties]');
        if (properties.getAttribute('data-properties')) {
            properties = JSON.parse(properties.getAttribute('data-properties'));
        }
        root.render(<App properties={properties}/>);
    }
});
